'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FONT_FAMILY = 'Open sans, Segoe UI, Tahoma, sans-serif';
var typography = {
  fontFamily: FONT_FAMILY,
  h1: {
    fontSize: '2.5rem',
    lineHeight: 1.2,
    fontWeight: 400
  },
  h2: {
    fontSize: '1.75rem',
    lineHeight: 1.44,
    fontWeight: 400
  },
  h3: {
    fontSize: '1.5rem',
    lineHeight: 1.5,
    fontWeight: 400
  },
  subtitle1: {
    fontSize: '1.125rem',
    lineHeight: 1.5,
    fontWeight: 600
  },
  subtitle2: {
    fontSize: '1rem',
    lineHeight: 1.5,
    fontWeight: 600
  },
  body1: {
    fontSize: '1rem',
    lineHeight: 1.75,
    fontWeight: 400
  },
  body2: {
    fontSize: '.875rem',
    lineHeight: 1.75,
    fontWeight: 400
  },
  caption: {
    fontSize: '.75rem',
    lineHeight: 1.75,
    fontWeight: 400
  },
  eyebrow: {
    fontSize: '.75rem',
    lineHeight: 2.67,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.08rem'
  },
  button: {
    fontSize: '1rem',
    lineHeight: 1,
    fontWeight: 600,
    textTransform: "none"
  }
};
var spacer = {
  centerContentMaxWidth: 1250
};

exports.FONT_FAMILY = FONT_FAMILY;
exports.spacer = spacer;
exports.typography = typography;
